<div class="top-corner">
    <div style="float:left" class="input-group">
      <a class="navbar-item">
      </a>
    </div>
</div><br><br>
<div class="login-form col">
  <form [formGroup]="userForm" style="box-shadow: 0 0 40px rgba(0, 0, 0, .5);">
    <div class="form-group">
      <div class="input-group">
      <a class="navbar-item">
        <img class="image-logo-1" src="assets/image/Logo-IOFE2.png">
      </a>
      </div>
    </div>
    <h2 class="text-center">{{ "TITLE.SIGN-IN" | translate }}</h2>
    <div class="form-group mt-1">
      <input type="text"
             class="form-control"
             formControlName="username"
             [(ngModel)]="user.username"
             [class.is-invalid]="isInvalidControl('username')"
             (keyup.enter)="verifyTwoFactAuthAndLogin(user)"
             placeholder="Usuario"
             required="required">
    </div>
    <div class="form-group">
      <div class="input-group">
        <input [type]="fieldTextType ? 'text' : 'password'"
               class="form-control"
               formControlName="password"
               [(ngModel)]="user.password"
               [class.is-invalid]="isInvalidControl('password')"
               (keyup.enter)="verifyTwoFactAuthAndLogin(user)"
               placeholder="Contraseña"
               required="required">
        <div class="input-group-append">
                <span class="input-group-text">
                <i class="fa {{fieldTextType?'fa-eye':'fa-eye-slash'}}"
                   (click)="toggleFieldTextType()"
                ></i>
              </span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <button type="button" class="btn btn-success btn-block" (click)="verifyTwoFactAuthAndLogin(user)"><i class="fas fa-sign-in" aria-hidden="true"></i> {{ "BUTTON.SIGN-IN" | translate }}</button>
    </div>
    <div class="text-center">
      <a [routerLink]="'/passwordrecovery'">{{ "QUESTION.RECOVER-PASS" | translate }}</a>
      <br>
      <small>{{ "MESSAGE.REVIEW-LABOR-DOCUMENT" | translate }}<a [routerLink]="'/temp-login'"> {{ "LINK.HERE" | translate }}</a></small>
    </div>
  </form>
</div>
<app-loading *ngIf="loading || allyLoading"></app-loading>
